export enum TriOptionActionTypeEnum {
  Cancel = 1,
  Discard = 2,
  Save = 3
}
